<template>
  <div class="tags-input__wrapper">
    <el-tag
      v-for="(tag, index) in dynamicTags"
      :key="tag + index"
      :size="tagSize"
      :type="tagType"
      :closable="true"
      :close-transition="false"
      @close="handleClose(tag)"
      class="mb-2"
    >
      {{ tag }}
    </el-tag>

    <validation-observer
      v-if="!maxed && !tagOnly"
      ref="input_observer"
      v-slot="{ invalid }"
    >
      <validation-provider :rules="rules">
        <b-input-group>
          <b-form-input
            v-model="inputValue"
            :type="type"
            :placeholder="placeholder"
            ref="saveTagInput"
            size="mini"
            class="mt-0"
            v-bind="$attrs"
            @input="onInput"
            @keyup.enter.prevent="handleInputConfirm"
            @blur="handleInputConfirm"
          ></b-form-input>
          <b-input-group-append>
            <b-button
              @click.stop.prevent="handleInputConfirm"
              :disabled="invalid"
              variant="primary"
              class="px-3"
            >
              <b-icon icon="plus"></b-icon>
            </b-button>
          </b-input-group-append>
        </b-input-group>
      </validation-provider>
    </validation-observer>
  </div>
</template>

<script>
import { Tag } from "element-ui";

export default {
  name: "tags-input",
  inheritAttrs: false,
  components: {
    [Tag.name]: Tag,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
      description: "List of tags",
    },
    tagSize: {
      type: String,
      default: "small",
    },
    tagType: {
      type: String,
      default: "primary",
      description: "Tag type (primary|danger etc)",
    },
    type: {
      type: String,
      default: "text",
    },
    placeholder: {
      type: String,
    },
    rules: {
      type: String,
      default: "required",
    },
    tagOnly: {
      type: Boolean,
      default: false,
    },
    max: {
      type: [Number, Boolean],
      default: false,
    },
  },
  model: {
    prop: "value",
    event: "change",
  },
  data() {
    return {
      dynamicTags: [],
      inputVisible: false,
      inputValue: "",
    };
  },
  computed: {
    maxed() {
      if (!this.max) return false;

      return this.value.length >= this.max;
    },
  },
  methods: {
    handleClose(tag) {
      this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
      this.$emit("change", this.dynamicTags);
    },
    showInput() {
      this.inputVisible = true;
      this.$nextTick(() => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    handleInputConfirm() {
      this.$refs.input_observer.validate().then((success) => {
        if (!success) return false;

        if (0 <= this.dynamicTags.indexOf(this.inputValue)) return false;

        this.dynamicTags.push(this.inputValue);
        this.$emit("change", this.dynamicTags);

        this.inputVisible = false;
        this.inputValue = "";
      });
    },
    onInput(evt) {
      this.$emit("input", "object" === typeof evt ? evt.target.value : evt);
    },
  },
  created() {
    this.$watch(
      "value",
      (newVal) => {
        this.dynamicTags = [...newVal];
      },
      { immediate: true }
    );
  },
};
</script>
